// src/routes/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { logout } from "./Logout";

export const ProtectedRoute = ({ children }) => {
  const jwtToken = localStorage.getItem("jwtToken");

  if (!jwtToken) {
    logout();
  }

  return children;
};
